import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"
import GeoMap from "@irati-web/geolocation/src/components/GeoMap/GeoMap"
import {greys} from "@irati/ui/src/global/colors"
import media, {minWidthMedia} from "@irati/ui/src/global/media"

const useRemainingViewportHeight = "height: calc(100vh - 285px);"

export const Container = styled.div`
  margin-top: ${padding.tiny};
`

export const CardsContainer = styled.div``
export const MapContainer = styled.div``

export const CardsMapContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  ${minWidthMedia.desktop`
    flex-direction: row;
  `}

  ${CardsContainer}{
    order: 1;

    ${minWidthMedia.desktop`
      order: 0;
      width: 40%;
      padding: 1px ${padding.tiny} 0px 1px;
      ${useRemainingViewportHeight}
      overflow: auto;
    `}

    ${media.desktop`
      margin: 0 -15px;
    `}
  }

  ${MapContainer}{
    order: 0;
    ${useRemainingViewportHeight}

    ${media.desktop`
      margin-bottom: 10px;
    `}

    ${minWidthMedia.desktop`
      order: 1;
      width: 60%;
      ${useRemainingViewportHeight}
    `}
  }
`

export const StyledMap = styled(GeoMap)`
  border: 1px solid ${greys.light};
`

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
